import { useHMSPeers } from "../hms";
import { useLivekitPeers } from "../livekit";
import type { ProviderPeers } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderPeers = (): ProviderPeers =>
  useProviderHook({
    hms: useHMSPeers,
    livekit: useLivekitPeers,
  })();
